import axios from 'axios'
import config from '../../config'

const baseUrl = `${config.backend}user/`

export const loginUser = async (data) => {
    const response = await axios.post(`${baseUrl}login`, data)
    return response.data
}
